var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "w-full col-span-full"
  }, [_c('div', {
    directives: [{
      name: "click-outside",
      rawName: "v-click-outside",
      value: _vm.hideSuggestionsList,
      expression: "hideSuggestionsList"
    }],
    staticClass: "relative flex items-center"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.mutableValue,
      expression: "mutableValue"
    }],
    staticClass: "bg-white rounded-md placeholder-gray-600 block w-full focus:outline-none focus:shadow-outline-indigo appearance-none transition duration-150 ease-in-out sm:leading-5 truncate",
    class: {
      'text-lg py-5 pl-5 pr-7': _vm.big != null && _vm.big,
      'text-sm pl-3 pr-8 py-2 xxl:pl-4 xxl:pr-11 xxl:py-3 2xl:pl-5 2xl:pr-13 2xl:py-4': _vm.big == null || !_vm.big,
      'border-red-500': _vm.error && _vm.errorMsg != '',
      'border-indigo-600': !(_vm.error && _vm.errorMsg != ''),
      shadow: !_vm.hasBorder,
      'border border-opacity-50 focus:border-indigo-300': _vm.hasBorder
    },
    attrs: {
      "name": _vm.name,
      "autocomplete": "off",
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": _vm.mutableValue
    },
    on: {
      "click": _vm.displaySuggestionsList,
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.mutableValue = $event.target.value;
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "absolute",
    class: {
      'right-4': _vm.big == null || !_vm.big,
      'right-5': _vm.big != null && _vm.big
    }
  }, [!_vm.isSearching ? _c('icon', {
    class: _vm.iconColor,
    attrs: {
      "name": _vm.icon
    }
  }) : _vm._e(), _vm._v(" "), _vm.isSearching ? _c('div', {
    staticClass: "flex justify-center border rounded-full h-3 w-3 mr-1 sm:h-4 sm:w-4 sm:mr-1.5 border-t-2 border-r-2 border-l-0 border-b-0 border-gray-900 border-opacity-25 animate-spin"
  }) : _vm._e()], 1), _vm._v(" "), _vm.hasSuggestion ? _c('div', {
    class: 'absolute bg-white shadow rounded-md ' + _vm.suggestionsListMaxHeight + ' w-full overflow-scroll mt-15 z-30 self-start'
  }, [_vm._t("suggestionsList")], 2) : _vm._e()]), _vm._v(" "), _vm.error ? _c('div', {
    staticClass: "text-red-500 text-sm"
  }, [_vm._v("\n    " + _vm._s(_vm.errorMsg) + "\n  ")]) : _vm._e()]);

}
var staticRenderFns = []

export { render, staticRenderFns }